// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"bf511692","844":"0ecdcc2a"}[chunkId] + ".css";
};